import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import classes from "./InvoiceCardBanner.module.css";
import { Avatar } from "@components";
import { useTranslation } from "react-i18next";
import Logo from "@assets/img/logo.png";
import Payment from "@assets/img/payment.png";
import Payment2 from "@assets/img/payment-2.png";

export const InvoiceCardBanner = ({ row, className, status }) => {
  const { t } = useTranslation();
  return (
    <div className={`${classes.card}`}>
      {/* <div className={`${classes.date} d-flex align-items-center`}>
        <span className={`icon-reset-2 ${classes.icon}`}></span>
        {row?.invoice_date}
      </div> */}
      <div className={`${classes.bodyRow} d-flex`}>
        <div className={`${classes.company}`}>
          <div className={`${classes.companyRow} d-flex align-items-center`}>
            <Avatar src={row?.company?.media?.url} className={classes.img} />{" "}
            <span className={`${classes.companyTitle} main-color`}>
              {row?.company?.name}
            </span>
          </div>
        </div>
      </div>

      <div className={`${classes.mainTitle} hidden-sm`}>
        <span className={`${classes.mainTitleKey}`}>{t("subject")}: </span>{" "}
        {row?.title}
      </div>
      <div className={`${classes.body}`}>
        <div className={`${classes.bodyBlock}`}>
          <div className={`${classes.left}`}>
            <div className={`${classes.bodyRowList} hidden-lg`}>
              <div className={`${classes.bodyRowKey}`}>{t("subject")}</div>
              <div className={`${classes.bodyRowValue}`}>{row?.subject}</div>
            </div>

            <div className={`${classes.bodyRowList}`}>
              <div className={`${classes.bodyRowKey}`}>{t("fullName")}</div>
              <div className={`${classes.bodyRowValue}`}>{row?.user?.name}</div>
            </div>

            <div className={`${classes.bodyRowList}`}>
              <div className={`${classes.bodyRowKey}`}>{t("civilNumber")}</div>
              <div className={`${classes.bodyRowValue}`}>
                {row?.user?.civilId}
              </div>
            </div>

            <div className={`${classes.bodyRowList}`}>
              <div className={`${classes.bodyRowKey}`}>{t("phoneNumber")}</div>
              <div className={`${classes.bodyRowValue} ${classes.valueNumber}`}>
                {row?.user?.country_code}
                {row?.user?.mobile}
              </div>
            </div>

            <div className={`${classes.bodyRowList}`}>
              <div className={`${classes.bodyRowKey}`}>
                {t("invoiceNumber")}
              </div>
              <div className={`${classes.bodyRowValue}`}>{row?.invoiceKey}</div>
            </div>

            <div className={`${classes.bodyRowList}`}>
              <div className={`${classes.bodyRowKey}`}>{t("date")}</div>
              <div className={`${classes.bodyRowValue}`}>
                {row?.invoiceDate}
              </div>
            </div>

            {row?.details ? (
              <div className={`${classes.bodyRowList}`}>
                <div className={`${classes.bodyRowKey}`}>{t("notes")}</div>
                <div className={`${classes.bodyRowValue} ${classes.notes}`}>
                  {row?.details}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>

          <div className={`${classes.right}`}>
            <div className={`${classes.bodyRowListEnd}`}>
              <div className={`${classes.bodyRowKeyDue}`}>{t("amountDue")}</div>
              <div className={`${classes.bodyRowValueDue}`}>
                {row?.amount} {row?.currency}
              </div>
            </div>
          </div>
        </div>

        <div className={`${classes.paymentBadge}`}>
          <div
            className={`${classes.paymentStatus} ${
              row?.paymentStatus === "pending" ? classes.pending : classes.paid
            } text-capitalize`}>
            {t(`Status.${row?.paymentStatus}`)}
          </div>
        </div>
      </div>

      <div className={`${classes.footer} pt-2`}>
        <div className="d-flex justify-content-end">
          <div className={`${classes.action} mt-2`}>
            <a
              className={`btn btn-primary ${classes.actionBtn}`}
              href={row?.paymentStatus === "paid" ? row?.pdf : row?.link}
              rel="noreferrer">
              {/* <Avatar src={Payment2} className={`icon`} /> */}
              {status === "paid" || row?.paymentStatus === "paid" ? (
                <>
                  <span class="icon-eye icon"></span> {t("view-invoice")}
                </>
              ) : (
                <>
                  <span class="icon-credit-card icon"></span> {t("payNow")}
                </>
              )}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
